import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FixedSizeList as List } from "react-window";
import Swal from "sweetalert2";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";
import {
  FormControl,
  InputLabel,
  InputAdornment,
  Select,
  Paper,
  Menu,
  MenuItem,
  Box,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  CircularProgress,
  TextField,
  Tooltip,
  IconButton,
  Pagination,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import GroupIcon from "@mui/icons-material/Group";
import PlaceIcon from "@mui/icons-material/Place";
import PublicIcon from "@mui/icons-material/Public";
import StoreIcon from "@mui/icons-material/Store";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../styles/vendorDashboard.module.css";
import SowModal from "../../shared/createForms/SowModal";
import FormatDateTimestamp from "../../helperFunctions/FormatDateTimestamp";
import AddIcon from "@mui/icons-material/Add";
import KamModal from "./Campaign/KamModal";
import RfpModal from "./Campaign/RFPModal.js";
import IPAssignModal from "./Campaign/IpAssignModal.js";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import QuestionnaireSelection from "../AdminportalFolder/PDI/Editablecomponent/QuestionnaireSelection.js";
import AssignQuestionnaireSelection from "../AdminportalFolder/PDI/Editablecomponent/AssignQuestionnaireSection.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import LogView from "../AdminportalFolder/Campaign/LogView.jsx";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CampaignEditModal from "../../shared/createForms/CampaignEditModal";
import CustomLoading from "../../shared/utils/CustomLoading";
import CampaignViewModal from "../../shared/createForms/CampaignViewModal";
import CampaignProductTable from "../../shared/createForms/CampaignProductTable";
import styles from "../../styles/adminPortal.module.css";
import DeletedUsersRestore from "../../shared/createForms/DeletedUsersRestore.jsx";
import { Close, DeleteOutline } from "@mui/icons-material";
import Person2Icon from "@mui/icons-material/Person2";
import VendorList from "./PoIssuedComponent/VendorList.jsx";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const getHeadCells = (role) => [
  { id: "campaignSerialNumber", label: "Campaign ID", width: 150 },
  { id: "client", label: "Organization Name", width: 160 },
  { id: "campaignTitle", label: "Campaign", width: 200 },
  { id: "timeline", label: "Timeline", width: 180 },
  { id: "campaign-owner", label: "Campaign Owner", width: 160 },
  { id: "locations", label: "States", width: 150 },
  { id: "stores", label: "Stores", width: 70 },
  // { id: "qty", label: "QTY", width: 60 },
  ...(role === "-1" || role === "1"
    ? [{ id: "budget", label: "Approved Spend", width: 140 }]
    : []),
  { id: "progress", label: "Progress", width: 100 },
  ...(role === "-1" || role === "1" || role === "0"
    ? [{ id: "assign", label: "Assign To Kam", width: 170 }]
    : []),
  { id: "assignIp", label: "Assign To IP", width: 170 },
  { id: "status", label: "Status", width: 120 },
  { id: "action", label: "Action", width: 30 },
];

function EnhancedTableHead(props) {
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setHeadCells(getHeadCells(role));
  }, []);
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        <TableCell
          className={styles.tableCell}
          padding="checkbox"
          sx={{ minWidth: 50 }}
        >
          <Checkbox
            indeterminate={props.someSelected && !props.allSelected}
            checked={props.allSelected}
            onChange={props.onSelectAllClick}
            disabled={!props.rowCount}
          />
        </TableCell>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {["client", "campaignTitle", "locations", "status"].includes(
                headCell.id,
              ) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const inputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState(""); // dropdown typing

  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [campaignSearchResults, setCampaignSearchResults] = useState([]);

  useEffect(() => {
    const results = props.campaignForSuggestion.map((campaign) => ({
      id: campaign._id,
      title: campaign.campaignTitle,
      campaignOwner: {
        name: campaign.campaignOwnerId?.name || "N/A",
        email: campaign.campaignOwnerId?.emailAddress || "N/A",
      },
      locations: campaign.locations || [],
      cities: campaign.cities || [],
      storeNames: campaign.storeNames || [],
    }));

    setCampaignSearchResults(results);
  }, [props.campaignForSuggestion]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsSearchOpen(false);
        inputRef.current?.blur();
        props.setAppliedSearch(searchQuery.trim());
        props.setPage(1); // reset pagination on escape as well
        setSearchQuery(""); // clear search input on escape
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      props.setAppliedSearch(searchQuery.trim());
      props.setPage(1); // reset pagination
      setIsSearchOpen(false); // close dropdown
      inputRef.current?.blur(); // ✅ correct blur
    }
  };

  const highlight = (text) => {
    if (!searchQuery) return text;
    const parts = text.split(new RegExp(`(${searchQuery})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === searchQuery.toLowerCase() ? (
        <span key={i} className="bg-yellow-500 text-black rounded">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const buildSearchResults = (query, campaignSearchResults) => {
    if (!query) return [];

    const q = query.toLowerCase();
    const results = [];

    campaignSearchResults.forEach((campaign) => {
      // Campaign Title
      if (campaign.title?.toLowerCase().includes(q)) {
        results.push({
          id: campaign.id,
          type: "campaign",
          label: campaign.title,
          subLabel: "Campaign",
        });
      }

      // Owner
      if (campaign.campaignOwner?.name?.toLowerCase().includes(q)) {
        results.push({
          id: campaign.id,
          type: "owner",
          label: campaign.title,
          subLabel: `User • ${campaign.campaignOwner.name} - ${campaign.campaignOwner.email}`,
        });
      }

      // States
      campaign.locations?.forEach((state) => {
        if (state.toLowerCase().includes(q)) {
          results.push({
            id: campaign.id,
            type: "state",
            label: campaign.title,
            subLabel: `State • ${state}`,
          });
        }
      });

      // Cities
      campaign.cities?.forEach((city) => {
        if (city.toLowerCase().includes(q)) {
          results.push({
            id: campaign.id,
            type: "city",
            label: campaign.title,
            subLabel: `City • ${city}`,
          });
        }
      });

      // Stores
      campaign.storeNames?.forEach((store) => {
        if (store.toLowerCase().includes(q)) {
          results.push({
            id: campaign.id,
            type: "store",
            label: campaign.title,
            subLabel: `Store • ${store}`,
          });
        }
      });
    });

    return results;
  };
  const searchResults = useMemo(() => {
    return buildSearchResults(searchQuery, campaignSearchResults);
  }, [searchQuery, campaignSearchResults]);

  const handleTrashOpen = async (e) => {
    props.getALLDeletedCampaigns();
    props.OnTrashModalOpen(true);
  };

  const Row = ({ index, style }) => {
    const item = searchResults[index];

    return (
      <div
        style={style}
        key={index}
        className="flex items-center justify-between gap-3 px-4 py-2 hover:bg-gray-200 cursor-pointer transition"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-sm">
            {item.type === "campaign" && (
              <CampaignOutlinedIcon fontSize="small" />
            )}
            {item.type === "owner" && <GroupIcon fontSize="small" />}
            {item.type === "city" && <PlaceIcon fontSize="small" />}
            {item.type === "state" && <PublicIcon fontSize="small" />}
            {item.type === "store" && <StoreIcon fontSize="small" />}
          </div>

          <div className="flex flex-col">
            <span className="text-sm font-medium">{highlight(item.label)}</span>
            <span className="text-xs text-gray-500">
              {highlight(item.subLabel)}
            </span>
          </div>
        </div>

        <ArrowOutwardIcon
          fontSize="small"
          onClick={() => navigate(`/adminportal/campaign/dashboard/${item.id}`)}
        />
      </div>
    );
  };

  return (
    <>
      <div className="border-b flex justify-between items-center h-14 pt-2">
        <div className="font-bold text-md text-gray-600">
          Total Campaign : {props.totalCampaign || "0"}
        </div>
        <div className="flex items-center gap-4">
          {/* search suggestions */}

          <div className="relative w-[450px]" ref={searchRef}>
            <TextField
              inputRef={inputRef}
              placeholder="Search By Store, Title..."
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
              onFocus={() => setIsSearchOpen(true)}
              fullWidth
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />

            {/* Dropdown */}
            {isSearchOpen && searchQuery && (
              <div className="absolute top-[45px] left-0 w-full bg-[#f5f5f5] text-black rounded-xl shadow-xl border border-gray-700 z-50 overflow-hidden">
                {/* Results */}
                <div className="max-h-[300px] overflow-y-auto">
                  {searchResults.length > 0 ? (
                    <List
                      height={300}
                      itemCount={searchResults.length}
                      itemSize={60}
                      width="100%"
                    >
                      {Row}
                    </List>
                  ) : (
                    <div className="p-4 text-sm text-gray-500">
                      No results found
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="flex justify-between text-xs text-gray-400 px-4 py-2 border-t border-gray-700">
                  <span>Press ↵ to select</span>
                  <span>ESC to close</span>
                </div>
              </div>
            )}
          </div>

          {localStorage.getItem("role") != 4 &&
            localStorage.getItem("role") != 7 && (
              <div className="width-36px">
                <GlobalButton
                  variant="secondary"
                  size="medium"
                  onClick={() => props.setShowQuestionnaire(true)}
                  rightIcon={<AddIcon style={{ fontSize: "18px" }} />}
                >
                  {`Add Template`}
                </GlobalButton>
              </div>
            )}
          {localStorage.getItem("role") == "-1" && (
            <>
              <Tooltip title="Trash">
                <IconButton onClick={handleTrashOpen}>
                  <DeleteOutline sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </div>
      </div>
    </>
  );
}

var oldData = [];

export default function EnhancedTable() {
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isCampaignProductTable, setIsCampaignProductTable] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [kamdata, setKamdata] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState({}); // State for selected value
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isEditModal, setIsEditModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [campaignData, setIsCampaignData] = useState({});
  const [openLogView, setOpenLogView] = useState(false);
  const [campaignListLoading, setCampaignListLoading] = useState(true);
  const [totalCampaign, setTotalCampaign] = useState("0");
  const [appliedSearch, setAppliedSearch] = useState(""); // table search

  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    phoneNumber: "",
    name: "",
  });
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [allDeletedCampaigns, setALLDeletedCampaigns] = useState([]);
  const [isTrashLoading, setTrashLoading] = useState(false);
  const [showAssignQuestionnaire, setShowAssignQuestionnaire] = useState(false);
  const [openIPModal, setOpenIPModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  let role = localStorage.getItem("role");

  const [kammodalOpen, setKamModalOpen] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [selectedCampaignKamId, setSelectedCampaignKamId] = useState(null);
  const [headCells, setHeadCells] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [openVendorModal, setOpenVendorModal] = useState(false);

  /* ---------------- BULK SELECTION / BULK ACTIONS ---------------- */
  const [selectedCampaignIds, setSelectedCampaignIds] = useState([]);
  const [bulkActionAnchorEl, setBulkActionAnchorEl] = useState(null);
  const [bulkDownloadLoading, setBulkDownloadLoading] = useState(false);

  /* ---------------- SELECTED IP OBJECT ---------------- */
  const selectedIpObj = useMemo(() => {
    return campaign?.installationPartnerId || null;
  }, [campaign]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setHeadCells(getHeadCells(role));
  }, []);

  const handleOpenKamModal = (e, v) => {
    setSelectedCampaignId(v._id); // Set the current campaign ID
    setSelectedCampaignKamId(v.keyAccountManagerId); // Set the current KAM ID (if any)
    setKamModalOpen(true); // Open the modal
  };
  let debounceTimeout = null;

  const handleCloseKamModal = () => setKamModalOpen(false);
  const getALLDeletedCampaigns = async () => {
    setTrashLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/campaign/allDeletedCampaigns`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setALLDeletedCampaigns(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };

  const fetchCampaigns = async (queryParams) => {
    try {
      setCampaignListLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/campaign/allCampaigns?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setCampaign(response?.data?.data);

        setTotalPages(response?.data?.totalPages);
        setPage(response?.data?.currentPage);

        // old set states
        setTotalCampaign(response?.data?.totalCampaignsCount);
        setKamdata(response?.data?.adminsData);
        oldData = response?.data?.data;

        // Initialize selected admins based on current keyAccountManagerId
        const initialSelectedAdmins = {};
        response.data.data.forEach((campaign) => {
          initialSelectedAdmins[campaign._id] =
            campaign.keyAccountManagerId || "";
        });
        setSelectedAdmin(initialSelectedAdmins);

        setCampaignListLoading(false);
      }
    } catch (error) {
      setCampaignListLoading(false);
      console.error("Error fetching filtered vendors:", error);
    } finally {
      setCampaignListLoading(false);
    }
  };

  const handlePageChange = async (e, value) => {
    setPage(value);
  };

  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
  };

  useEffect(() => {
    const allFieldsEmpty = Object.values(searchInputs).every(
      (val) => val.trim() === "",
    );

    const timer = setTimeout(() => {
      // if (allFieldsEmpty) {
      //   // setFilteredVPCount(0);
      //   getCampaignList(1, pageSize);
      //   return;
      // }

      const queryParams = new URLSearchParams();

      Object.entries(searchInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      queryParams.append("page", page);
      queryParams.append("getFromClient", false);
      queryParams.append("limit", pageSize);
      queryParams.append("searchQuery", appliedSearch);

      fetchCampaigns(queryParams.toString());
    }, 300); // Debounce delay

    return () => clearTimeout(timer);
  }, [searchInputs, pageSize, page, appliedSearch]);

  const refreshWithCurrentFilters = async () => {
    const queryParams = new URLSearchParams();

    // Add all current search filters
    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue && searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add current page and page size
    queryParams.append("page", page);
    queryParams.append("limit", pageSize);
    queryParams.append("searchQuery", appliedSearch);

    await fetchCampaigns(queryParams.toString());
  };

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value.toLowerCase();
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setPage(1);
  };

  function formatLocation(location) {
    const firstTwoStates = location.slice(0, 2).join(", ");
    const remainingStatesCount =
      location.length > 2 ? ` +${location.length - 2}` : "";
    return firstTwoStates + remainingStatesCount;
  }
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // short month format (e.g., Oct)
    const year = date.getFullYear().toString().slice(-2); // last two digits of the year

    return `${day} ${month} ${year}`;
  };

  const getKAMNamesForTooltip = (ids) => {
    // Map through KAM IDs and return the corresponding names
    const kamNames = ids.map((id) => {
      const kam = kamdata.find((kam) => kam._id === id);
      return kam ? kam.name : "No KAM Assigned";
    });
    // Return the full list of names
    return kamNames.join(", ");
  };

  const getKAMName = (ids) => {
    // If ids is an array, map through it and find the corresponding KAM names
    const kamNames = ids
      .map((id) => {
        const kam = kamdata.find((kam) => kam._id === id);
        return kam ? kam?.name : "No KAM Assigned";
      })
      .slice(0, 2); // Only take the first two names

    // If there are more than 2 KAMs, add the '+X' for extra KAMs
    const extraKAMCount = ids.length - 2;

    // Combine the names with a comma and add '+X' if there are more than 2 KAMs
    return (
      kamNames.join(", ") + (extraKAMCount > 0 ? ` +${extraKAMCount}` : "")
    );
  };

  // Selection is intentionally NOT cleared on page/filter change, so users can
  // select campaigns across multiple pages/filters before running a bulk action.
  const isCampaignSelected = (id) => selectedCampaignIds.includes(id);

  const handleSelectRow = (e, id) => {
    e.stopPropagation();
    setSelectedCampaignIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  // "Select all" only affects the campaigns currently visible on this page —
  // it adds them to (or removes them from) whatever was already selected on
  // other pages, rather than wiping out the whole selection.
  const handleSelectAllClick = (e) => {
    const visibleIds = campaign.map((v) => v._id);
    if (e.target.checked) {
      setSelectedCampaignIds((prev) => [
        ...prev,
        ...visibleIds.filter((id) => !prev.includes(id)),
      ]);
    } else {
      setSelectedCampaignIds((prev) =>
        prev.filter((id) => !visibleIds.includes(id)),
      );
    }
  };

  const handleClearSelection = () => setSelectedCampaignIds([]);

  const handleBulkActionOpen = (e) => {
    setBulkActionAnchorEl(e.currentTarget);
  };

  const handleBulkActionClose = () => {
    setBulkActionAnchorEl(null);
  };

  const handleBulkRecceDownload = async () => {
    if (!selectedCampaignIds.length) return;
    try {
      setBulkDownloadLoading(true);
      setBulkActionAnchorEl(null);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${serverURL}/excelData/recceJobs/multiple`,
        { campaignIds: selectedCampaignIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Treat the response as a binary blob
        },
      );

      const contentDisposition = response.headers["content-disposition"];

      let fileName = "RecceJobs_Multiple.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);

        if (match && match[1]) {
          fileName = match[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading bulk Recce report:", error);
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text:
          error.response?.data?.message ||
          "Failed to download report for the selected campaigns",
      });
    } finally {
      setBulkDownloadLoading(false);
    }
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  const handleEditModal = (e, v, operation) => {
    setAnchorEl(null);

    if (operation === "template") {
      setShowAssignQuestionnaire(true);
      setSelectedCampaignId(v._id);
      return; // stop here (no axios call)
    } else if (operation === "logs") {
      setOpenLogView(true);
      setSelectedCampaignId(v._id);
      return;
    } else if (operation === "dashboard") {
      navigate(`/adminportal/campaign/dashboard/${v._id}`);
    } else if (operation === "products") {
      navigate(`/adminportal/campaign/${v._id}`);
    } else {
      // 🟣 Step 2: Normal flow for others
      setIsActionLoading(true);

      axios
        .get(`${serverURL}/campaign/viewCampaign/${v._id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          if (response.data.success === true) {
            setIsCampaignData(response.data.data);

            if (operation === "edit") {
              setIsEditModal(true);
            } else if (operation === "products") {
              navigate(`/adminportal/campaign/${v._id}`);
            } else if (operation === "view") {
              setIsViewModal(true);
            } else if (operation === "dashboard") {
              navigate(`/adminportal/campaign/dashboard/${v._id}`);
            }
          }
        })
        .catch((error) => console.error("Error fetching campaign:", error))
        .finally(() => setIsActionLoading(false));
    }
  };

  const handleDelete = async (e, v) => {
    setAnchorEl(null);
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      icon: "warning",
      text: "Do you want to delete this Campaign?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${serverURL}/campaign/deleteCampaign/${v._id}`,

            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );

          if (response.data.success === true) {
            // Show success message
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              text: response.data.message,
              padding: "1em",
            }).then(() => {
              refreshWithCurrentFilters();
            });
          }
        } catch (error) {
          console.error("Error deleting campaign:", error);

          // Show error message if delete fails
          Swal.fire({
            customClass: {
              container: "my-swal",
            },
            icon: "error",
            text: error.response?.data?.message || "An error occurred",
            color: "black",
          });
        }
      }
    });
  };

  const handleVendorModal = async (e, v) => {
    //console.log("hi po issued", e.target.value, v);

    // vendor data save
    setSelectedVendor(v);

    // modal open
    setOpenVendorModal(true);
  };

  const [allCampaigns, setAllCampaigns] = useState([]); // State to hold all campaigns for search suggestions

  useEffect(() => {
    const fetchAllCampaignsForSuggestions = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_URL}/campaign/search-suggestions`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (res.data.success) {
          setAllCampaigns(res.data.data); // 🔥 full dataset
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchAllCampaignsForSuggestions();
  }, []);

  const rejectAllPendingJobs = async (campaignId) => {
    setAnchorEl(null);
    const result = await Swal.fire({
      title: "Reject All Pending Jobs?",
      text: "All pending installation jobs for this campaign will be rejected. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Reject All",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      Swal.fire({
        title: "Please wait...",
        text: "Rejecting pending jobs...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const { data } = await axios.post(
        `${serverURL}/campaign/allPendingJobs/${campaignId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text:
          data.message || "All pending jobs have been rejected successfully.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text:
          error.response?.data?.error ||
          "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <div className={styles.tableGround}>
      <Box>
        <>
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <EnhancedTableToolbar
              userVenderData={refreshWithCurrentFilters}
              OnModalOpen={(value) => handleModalOpen(value)}
              onSearchChange={(value) => handleSearchChangeHead(value)}
              totalCampaign={totalCampaign}
              setShowQuestionnaire={setShowQuestionnaire}
              OnTrashModalOpen={setIsTrashModalOpen}
              getALLDeletedCampaigns={getALLDeletedCampaigns}
              campaignForSuggestion={allCampaigns}
              handleEditModal={handleEditModal}
              appliedSearch={appliedSearch}
              setAppliedSearch={setAppliedSearch}
              setPage={setPage}
            />
            {selectedCampaignIds.length > 0 && (
              <Box
                className="flex items-center justify-between"
                sx={{
                  backgroundColor: "#E1ECFF",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  margin: "8px 0",
                }}
              >
                <div className="flex items-center gap-3">
                  <span className="font-semibold text-[#093EBC] text-sm">
                    {selectedCampaignIds.length} Campaign
                    {selectedCampaignIds.length > 1 ? "s" : ""} Selected
                  </span>
                  <button
                    onClick={handleClearSelection}
                    className="text-xs font-semibold text-[#093EBC] underline"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Clear selection
                  </button>
                </div>
                <Tooltip title="Bulk Actions">
                  <IconButton
                    onClick={handleBulkActionOpen}
                    disabled={bulkDownloadLoading}
                  >
                    {bulkDownloadLoading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <MoreVertIcon style={{ color: "var(--primary-color)" }} />
                    )}
                  </IconButton>
                </Tooltip>
                <Menu
                  anchorEl={bulkActionAnchorEl}
                  open={Boolean(bulkActionAnchorEl)}
                  onClose={handleBulkActionClose}
                  keepMounted
                >
                  <MenuItem onClick={handleBulkRecceDownload}>
                    <DownloadOutlinedIcon style={{ color: "#6b7280" }} />
                    <p className="ml-2 font-semibold text-[#6b7280]">
                      Download Report
                    </p>
                  </MenuItem>
                  {/* Add more bulk actions here as needed */}
                </Menu>
              </Box>
            )}
            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  className="rounded-lg "
                >
                  <EnhancedTableHead
                    rowCount={campaign.length}
                    userListData={refreshWithCurrentFilters}
                    setSearchInputs={setSearchInputs} // Function to update search inputs
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                    allSelected={
                      campaign.length > 0 &&
                      campaign.every((v) => selectedCampaignIds.includes(v._id))
                    }
                    someSelected={campaign.some((v) =>
                      selectedCampaignIds.includes(v._id),
                    )}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  {campaignListLoading ? (
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length + 1}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          <CircularProgress />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : !campaign || campaign?.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length + 1}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No Campaign found
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableBody>
                      {campaign.map((v, index) => {
                        return (
                          <TableRow
                            hover
                            key={index}
                            className={styles.tableRowHead}
                            onClick={(e) => handleEditModal(e, v, "dashboard")}
                            // sx={{ height: "60px" }}
                            tabIndex={-1}
                            selected={isCampaignSelected(v._id)}
                          >
                            <TableCell
                              padding="checkbox"
                              className={styles.tableRow}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Checkbox
                                checked={isCampaignSelected(v._id)}
                                onChange={(e) => handleSelectRow(e, v._id)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>
                                {v?.campaignSerialNumber || "Not Available"}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <Tooltip
                                title={
                                  v.organizationId?.name?.length > 25
                                    ? v.organizationId?.name
                                    : ""
                                }
                                arrow
                                placement="top"
                              >
                                <span className={styles.truncateText}>
                                  {v.organizationId?.name?.length > 25
                                    ? `${v.organizationId?.name.slice(
                                        0,
                                        25,
                                      )}...`
                                    : v.organizationId?.name || "Not Available"}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <Tooltip
                                title={
                                  v?.campaignTitle?.length > 25
                                    ? v?.campaignTitle
                                    : ""
                                }
                                arrow
                                placement="top"
                              >
                                <span className={styles.truncateText}>
                                  {v.campaignTitle?.length > 25
                                    ? `${v.campaignTitle.slice(0, 25)}...`
                                    : v.campaignTitle?.charAt(0).toUpperCase() +
                                        v?.campaignTitle.slice(1) ||
                                      "Not Available"}
                                </span>
                              </Tooltip>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <span>
                                {formatDate(v?.startDate)} -{" "}
                                {formatDate(v?.endDate)}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <Tooltip title={v.campaignOwnerId?.name} arrow>
                                <span style={{ display: "block" }}>
                                  {v.campaignOwnerId?.name?.length > 25
                                    ? `${v.campaignOwnerId?.name.slice(
                                        0,
                                        25,
                                      )}...`
                                    : v.campaignOwnerId?.name ||
                                      "Not Available"}
                                </span>
                              </Tooltip>
                              <Tooltip
                                title={v.campaignOwnerId?.emailAddress}
                                arrow
                              >
                                <span className="text-gray-400">
                                  {v.campaignOwnerId?.emailAddress?.length > 25
                                    ? `${v.campaignOwnerId?.emailAddress
                                        .toLowerCase()
                                        .slice(0, 25)}...`
                                    : v.campaignOwnerId?.emailAddress.toLowerCase() ||
                                      "Not Available"}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <Tooltip title={v.locations.join(", ")} arrow>
                                <span>{formatLocation(v?.locations)}</span>
                              </Tooltip>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>{v.stores || "Not Available"}</span>
                            </TableCell>
                            {/* <TableCell className={styles.tableRow}>
                              <span>{v.quantity || "0"}</span>
                            </TableCell> */}
                            {(role === "-1" || role === "1") && (
                              <TableCell className={styles.tableRow}>
                                <span>
                                  ₹{" "}
                                  {(v?.budget || 0).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </span>
                                {/* <span>₹ {formatNumber(v?.budget ?? 0)}</span> */}
                              </TableCell>
                            )}
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center items-center">
                                <div
                                  className="w-full bg-gray-200 rounded-full dark:bg-[#E1ECFF]"
                                  style={{ width: "6vw", height: "0.5rem" }}
                                >
                                  <div
                                    className="bg-[#418CFF] text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                                    style={{
                                      width: `${v?.progress}%`,
                                      height: "0.5rem",
                                    }}
                                  ></div>
                                </div>
                                <span className="mx-2 text-gray-500 text-sm">
                                  {Math.round(v?.progress.toFixed(1) ?? "0")}%
                                </span>
                              </div>
                            </TableCell>
                            {(localStorage.getItem("role") == "-1" ||
                              localStorage.getItem("role") == "0" ||
                              localStorage.getItem("role") == "1") && (
                              <>
                                <TableCell
                                  className={styles.tableRow}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <RfpModal
                                    kamdata={kamdata || []}
                                    campaignModal={true}
                                    initialSelected={
                                      v.keyAccountManagerId || []
                                    } // pehle se assigned KAMs (ids ya objects)
                                    onChange={async (selected) => {
                                      try {
                                        const token =
                                          localStorage.getItem("token");
                                        const keyAccountManagerId =
                                          selected.map((s) => s._id);

                                        // API call same as modal me tha
                                        await axios.put(
                                          `${process.env.REACT_APP_URL}/campaign/assignAdmin/${v._id}`,
                                          { keyAccountManagerId },
                                          {
                                            headers: {
                                              Authorization: `Bearer ${token}`,
                                            },
                                          },
                                        );
                                        await refreshWithCurrentFilters();
                                      } catch (err) {
                                        console.error(
                                          "Error assigning KAM:",
                                          err,
                                        );
                                      }
                                    }}
                                  />
                                </TableCell>
                                {/* <KamModal
                                    getCampaignList={getCampaignList}
                                    campaignKamID={selectedCampaignKamId}
                                    campaignID={selectedCampaignId}
                                    kamdata={kamdata}
                                    open={kammodalOpen}
                                    onClose={handleCloseKamModal}
                                  /> */}
                              </>
                            )}

                            <TableCell
                              className={styles.tableRow}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Box className="flex items-center gap-2">
                                <Tooltip title="Assign Installation Partner">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      setSelectedCampaign(v);
                                      setOpenIPModal(true); // 👈 modal open
                                    }}
                                  >
                                    <PersonAddAltIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip
                                  title={
                                    v.assignedInstallationPartners.length >
                                    0 ? (
                                      <div>
                                        {v.assignedInstallationPartners.map(
                                          (s, i) => (
                                            <div key={s.id ?? i}>
                                              {i + 1}. {s.name}
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    ) : (
                                      "No Installation Partner Assigned"
                                    )
                                  }
                                  arrow
                                >
                                  <span style={{ display: "inline-block" }}>
                                    {v.assignedInstallationPartners.length > 0
                                      ? `${
                                          v.assignedInstallationPartners[0].name
                                        }${
                                          v.assignedInstallationPartners
                                            .length > 1
                                            ? ` +${
                                                v.assignedInstallationPartners
                                                  .length - 1
                                              }`
                                            : ""
                                        }`
                                      : "Select IP"}
                                  </span>
                                </Tooltip>
                              </Box>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              {v.progress >= 0 && v.progress < 100 ? (
                                <Chip
                                  label="Ongoing"
                                  sx={{
                                    backgroundColor: "#D0F4FF", // Custom background color
                                    color: "#093EBC", // Custom text color
                                    marginLeft: 1,
                                  }}
                                />
                              ) : (
                                <Chip
                                  label="Complete"
                                  sx={{
                                    backgroundColor: "#DDFFD3", // Custom background color
                                    color: "#358C09", // Custom text color
                                    marginLeft: 1,
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              className={styles.tableRow}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Tooltip title="Click">
                                <IconButton
                                  onClick={(e) => handleIconOpen(e, v._id)}
                                >
                                  <MoreVertIcon
                                    style={{ color: "var(--primary-color)" }}
                                  />
                                </IconButton>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={
                                    Boolean(anchorEl) && selectedRowId === v._id
                                  }
                                  onClose={handleIconClose}
                                  keepMounted
                                >
                                  <MenuItem
                                    onClick={(e) =>
                                      handleEditModal(e, v, "dashboard")
                                    }
                                    disabled={isActionLoading}
                                  >
                                    <DashboardOutlinedIcon
                                      style={{ color: "#6b7280" }}
                                    />
                                    <p className="ml-2 font-semibold text-[#6b7280]">
                                      Dashboard
                                    </p>
                                  </MenuItem>

                                  {localStorage.getItem("role") != 4 &&
                                    localStorage.getItem("role") != 7 && (
                                      <>
                                        <MenuItem
                                          onClick={(e) =>
                                            handleEditModal(e, v, "products")
                                          }
                                          disabled={isActionLoading}
                                        >
                                          <WorkHistoryOutlinedIcon
                                            style={{ color: "#6b7280" }}
                                          />
                                          <p className="ml-2 font-semibold text-[#6b7280]">
                                            Jobs
                                          </p>
                                        </MenuItem>
                                        {localStorage.getItem("role") != 7 && (
                                          <MenuItem
                                            onClick={(e) =>
                                              handleEditModal(e, v, "template")
                                            }
                                            disabled={isActionLoading}
                                          >
                                            <VisibilityIcon
                                              style={{ color: "#6b7280" }}
                                            />
                                            <p className="ml-2 font-semibold text-[#6b7280]">
                                              Question Template
                                            </p>
                                          </MenuItem>
                                        )}
                                      </>
                                    )}

                                  {role == -1 && (
                                    <MenuItem
                                      onClick={(e) =>
                                        handleEditModal(e, v, "logs")
                                      }
                                    >
                                      <AccessTimeIcon
                                        style={{ color: "#6b7280" }}
                                      />
                                      <p className="ml-2 font-semibold text-[#6b7280]">
                                        {"Logs"}
                                      </p>
                                    </MenuItem>
                                  )}
                                  {/* {role == -1 && (
                                    <MenuItem
                                      onClick={(e) =>
                                        handleVendorModal(e, v, "PoIssued")
                                      }
                                    >
                                      <Person2Icon
                                        style={{ color: "#6b7280" }}
                                      />
                                      <p className="ml-2 font-semibold text-[#6b7280]">
                                        {"View Vendor"}
                                      </p>
                                    </MenuItem>
                                  )} */}

                                  <MenuItem
                                    onClick={(e) => rejectAllPendingJobs(v._id)}
                                    disabled={isActionLoading}
                                  >
                                    <DeleteForeverIcon
                                      style={{ color: "#6b7280" }}
                                    />
                                    <p className="ml-2 font-semibold text-[#6b7280]">
                                      {`Delete Pending Jobs`}
                                    </p>
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      navigate(
                                        `/adminPortal/campaign/assign-delivery-center/${v._id}`,
                                      );
                                      handleIconClose();
                                    }}
                                  >
                                    <WarehouseOutlinedIcon
                                      style={{ color: "#6b7280" }}
                                    />
                                    <p className="ml-2 font-semibold text-[#6b7280]">{`Assign Delivery center`}</p>
                                  </MenuItem>
                                  {role == -1 && (
                                    <MenuItem
                                      onClick={(e) => handleDelete(e, v)}
                                    >
                                      <DeleteOutlinedIcon
                                        style={{ color: "red" }}
                                      />{" "}
                                      <p className="ml-2 font-semibold text-[red]">
                                        Delete
                                      </p>
                                    </MenuItem>
                                  )}
                                </Menu>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />

              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
            </>

            {showQuestionnaire && (
              <QuestionnaireSelection
                showQuestionnaire={showQuestionnaire}
                onClose={() => setShowQuestionnaire(false)}
              />
            )}

            {showAssignQuestionnaire && (
              <AssignQuestionnaireSelection
                onClose={() => setShowAssignQuestionnaire(false)}
                selectedCampaignId={selectedCampaignId}
              />
            )}
          </Paper>
        </>
      </Box>
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isTrashModalOpen && (
          <DeletedUsersRestore
            list={allDeletedCampaigns}
            type="CAMPAIGN"
            openModal={isTrashModalOpen}
            loading={isTrashLoading}
            getAllDeletedUsers={getALLDeletedCampaigns}
            setIsTrashModalOpen={setIsTrashModalOpen}
            setTrashLoading={setTrashLoading}
            getAllList={refreshWithCurrentFilters}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isEditModal && (
          <CampaignEditModal
            campaignData={campaignData}
            isEditModal={isEditModal}
            getCampaignList={refreshWithCurrentFilters}
            setIsEditModal={setIsEditModal}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isViewModal && (
          <CampaignViewModal
            campaignData={campaignData}
            isViewModal={isViewModal}
            getCampaignList={refreshWithCurrentFilters}
            setIsViewModal={setIsViewModal}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isCampaignProductTable && (
          <CampaignProductTable
            campaignData={campaignData}
            isCampaignProductTable={isCampaignProductTable}
            setIsCampaignProductTable={setIsCampaignProductTable}
          />
        )
      )}
      <Dialog
        open={openVendorModal}
        onClose={() => setOpenVendorModal(false)}
        maxWidth="lg"
        fullWidth
      >
        {/* Header */}
        <DialogTitle>
          Vendor List
          <IconButton
            onClick={() => setOpenVendorModal(false)}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        {/* Body */}
        <DialogContent>
          <VendorList
            openVendorModal={openVendorModal}
            setOpenVendorModal={setOpenVendorModal}
          />
        </DialogContent>
      </Dialog>
      {openIPModal && selectedCampaign && (
        <IPAssignModal
          open={openIPModal}
          onClose={() => {
            setOpenIPModal(false);
            setSelectedCampaign(null);
          }}
          campaignId={selectedCampaign._id}
          initialSelected={
            selectedCampaign.assignedInstallationPartners || null
          }
          getCampaignList={refreshWithCurrentFilters}
        />
      )}
      {openLogView && (
        <LogView
          openLogView={openLogView}
          setOpenLogView={setOpenLogView}
          selectedCampaignId={selectedCampaignId}
        />
      )}
    </div>
  );
}
